module.exports = __webpack_public_path__ + "static/beach-2a6cdee0c8cae86c25a31383a8a38454.png";